// This file contains JavaScript code for change redemptionRate.
// Navigating between the wizard steps (form -> confirm -> back) happens fully
// client-side via window.dialog.open({ elemId }), reusing markup that is already
// rendered (hidden) on the page. The "open form" and "back" buttons rely on the
// dialog component's generic [data-elem-id] auto-binding (see Dialog.js), so no
// custom handlers are needed for those. Only the actual submit
// (confirmRepaymentChangeForm) performs a server call, since that is the only
// step that changes data.

export function initRepaymentRatePage() {
    document.querySelectorAll(".repayment-form-submit").forEach((button) => {
        button.addEventListener("click", submitDialogForm);
    });
    document.querySelectorAll(".confirm-repayment-change").forEach((button) => {
        button.addEventListener("click", confirmRepaymentChangeForm);
    });
    document.querySelectorAll(".repayment-form-cancel").forEach((button) => {
        button.addEventListener("click", closeDialogForm);
    });
    document.addEventListener('dialog:beforeclose', function (event) {
        const cancelBtn = document.querySelector('.dialog-close');
        if (cancelBtn) {
            cancelBtn.addEventListener("click", closeDialogForm);
        }
    });
    
}

function fieldId(loanPartNumber, fieldName) {
    return "LoanPart" + loanPartNumber + "_" + fieldName;
}

function fieldName(loanPartNumber, fieldName) {
    return "LoanPart" + loanPartNumber + "." + fieldName;
}

function closeDialogForm(event) {
    event.preventDefault();
    const container = document.querySelector('[id^="repaymentRate-form"]');
    if (container) {
        const loanPartNumber = container.id.replace('repaymentRate-form-', '');
        const newRepaymentRate = document.getElementById(fieldId(loanPartNumber, "RepaymentRateNew"));
        newRepaymentRate.value = "";
    }

    window.dialog.close('acknowledged');
}

function submitDialogForm(event) {
    const submitBtn = event.currentTarget;

    event.preventDefault();

    const loanPartNumber = submitBtn.dataset.loanPartNumber;

    const fieldElement = document.querySelector('[data-form-field-name="' + fieldId(loanPartNumber, "RepaymentRateNew") + '"]');
    if (fieldElement) {
        fieldElement.classList.add("is-invalid");
    }

    const form = $("#ChangeRepaymentForm-" + loanPartNumber);
    if (!form.valid()) {
        return;
    }

    const newRepaymentRateField = document.getElementById(fieldId(loanPartNumber, "RepaymentRateNew"));
    const maxRepaymentRateField = document.getElementById(fieldId(loanPartNumber, "MaxRepaymentRate"));
    const minRepaymentRateField = document.getElementById(fieldId(loanPartNumber, "MinRepaymentRate"));

    if (!newRepaymentRateField) {
        return;
    }

    const newRepaymentRateDecimalValue = parseFloat(newRepaymentRateField.value.replace(/,/g, '.')).toFixed(2);
    newRepaymentRateField.value = newRepaymentRateDecimalValue.replace('.', ',');
    const maxRepaymentRateDecimalValue = parseFloat(maxRepaymentRateField.value);
    const minRepaymentRateDecimalValue = parseFloat(minRepaymentRateField.value);

    if (isNaN(newRepaymentRateDecimalValue) || newRepaymentRateDecimalValue < minRepaymentRateDecimalValue || newRepaymentRateDecimalValue > maxRepaymentRateDecimalValue) {
        newRepaymentRateField.setAttribute("aria-invalid", "true");
        const validationElement = document.querySelector('[data-valmsg-for="' + fieldName(loanPartNumber, "RepaymentRateNew") + '"]');
        if (validationElement) {
            validationElement.classList.remove("field-validation-valid");
            validationElement.classList.add("field-validation-error");
            const errorSpan = document.createElement("span");
            errorSpan.id = "RepaymentRateNew-error-" + loanPartNumber;
            errorSpan.textContent = "Ihr neuer Tilgungssatz sollte mindestens " + minRepaymentRateField.value.replace(/\./g, ",") + "% und h\u00F6chstens " + maxRepaymentRateField.value.replace(/\./g, ",") + "% betragen.";
            validationElement.appendChild(errorSpan);
        }
        return;
    }

    updateConfirmationStep(loanPartNumber, newRepaymentRateDecimalValue);

    window.dialog.open({
        elemId: "repaymentRate-confirm-" + loanPartNumber,
        title: submitBtn.dataset.title
    });
}

function updateConfirmationStep(loanPartNumber, newRepaymentRateDecimalValue) {
    const confirmContainer = document.getElementById("repaymentRate-confirm-" + loanPartNumber);
    if (!confirmContainer) return;

    const displayValue = newRepaymentRateDecimalValue.replace('.', ',');
    const displayElement = confirmContainer.querySelector('[data-role="repayment-rate-new-value"]');
    if (displayElement) {
        displayElement.textContent = displayValue + "%";
    }

    const confirmBtn = confirmContainer.querySelector(".confirm-repayment-change");
    if (confirmBtn) {
        confirmBtn.dataset.href = confirmBtn.dataset.baseHref + "&repaymentRateNew=" + newRepaymentRateDecimalValue;
    }
}

function confirmRepaymentChangeForm(event) {
    const confirmBtn = event.currentTarget;

    confirmBtn.classList.add('loading');
    event.preventDefault();
    const href = confirmBtn.dataset.href;
    if (!href) return;

    try {
        fetch(href, {
            method: 'POST',
            credentials: 'same-origin',
            redirect: 'manual'
        })
            .then(response => response.json())
            .then(data => {
                if (data.redirectTo) {
                    window.location.href = data.redirectTo;
                }
            })
            .catch(error => console.error('Error:', error));

    } catch (err) {
        console.error('Submit failed', err);
    }
}
